import * as React from 'react';
import {ImageValue} from 'api/lesson/types';
import Container from 'containers/Container';
import Column from './Column';

export interface ImageTemplateProps {
  value?: ImageValue;
}

/**
 * This is the image block of the lesson viewer.
 * @param {ImageTemplateProps} props
 * @return {React.ReactElement<ImageTemplateProps> | null}
 * @constructor
 */
export default function ImageTemplate(
    props: ImageTemplateProps,
): React.ReactElement<ImageTemplateProps> | null {
  return props.value ? (
    <Container>
      {props.value.map((column, index) => column && (
        <Column key={index} value={column} />
      ))}
    </Container>
  ) : null;
}
